// @owners { team: patients }
import { CommsVerificationInvalidChannel, CommsVerificationStatus } from '@alto/features';
import { useNavigation } from '@alto/navigation';
import React from 'react';
import { CommsVerificationPageBackground } from './CommsVerificationPageBackground';

export const UnauthCommsVerificationStatus = () => {
  const { getParam } = useNavigation<'RouteCommsVerificationStatusUnauthed'>();
  const commsChannel = getParam('commsChannel') || '';
  const token = getParam('token') || '';
  const verificationStatus = getParam('verificationStatus');

  if (commsChannel !== 'phone' && commsChannel !== 'email') {
    return (
      <CommsVerificationPageBackground>
        <CommsVerificationInvalidChannel authorized={false} />
      </CommsVerificationPageBackground>
    );
  }

  return (
    <CommsVerificationPageBackground>
      <CommsVerificationStatus
        isVerified={verificationStatus === 'success'}
        loading={false}
        commsChannel={commsChannel}
        authorized={false}
        token={token}
      />
    </CommsVerificationPageBackground>
  );
};
